var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("c-step", {
    attrs: {
      stepperGrpCd: "IIM_ACCIDENT_STEP_CD",
      currentStepCd: _vm.currentStepCd,
      param: _vm.param,
      contentHeight: _vm.contentHeight,
      isApprovePop: true,
    },
    on: {
      currentStep: _vm.currentStep,
      closePopup: _vm.closePopup,
      stepClick: _vm.stepClick,
    },
    model: {
      value: _vm.stepCd,
      callback: function ($$v) {
        _vm.stepCd = $$v
      },
      expression: "stepCd",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }